var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5H1L0 3.5V13.5L1 14.5H3.5H4.5H6.5H7.5H9H10H15L16 13.5V3.5L15 2.5ZM2 12.5V4.5H3.5V12.5H2ZM4.5 12.5V4.5H6.5V12.5H4.5ZM7.5 12.5V4.5H9V12.5H7.5ZM14 12.5H10V4.5H14V12.5ZM11 6.5V5.5H13V6.5H11Z",
    fill: "#464646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white",
    transform: "translate(0 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct16);
export default __webpack_public_path__ + "static/media/product16.202fe9493be6c7e44193563a290ac67e.svg";
export { ForwardRef as ReactComponent };